// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dynamic-table .ui-table{overflow:visible}.dynamic-table th{text-transform:uppercase}.dynamic-table__row-column:hover{cursor:pointer}.dynamic-table__row-column div.data{text-overflow:ellipsis}.ui-table-row{border-left:4px solid rgba(0,0,0,0)}.ui-table-row--hoverable:hover td:first-child{border-left:4px solid #4467ab}", ""]);
// Exports
module.exports = exports;
